<p-card>
  <div class="grid" >
    
      <div class="col-12 md:col-12 lg:col-12 breadcrumbrightmenu" >
          <div   class="text-end p-0 border-round-sm font-bold">
            <p-button (click)="show('Add Unlicensed User','','')" styleClass="customAdd p-button-sm p-button-raised mr-4"
          icon="fa fa-plus p-button-icon ng-star-inserted" pTooltip="Add Unlicensed User"
          tooltipPosition="left"></p-button>
          <button class="fa fa-question helpicon" pTooltip="Help"
          (click)="helpservice.openhelpmodal(ref,dialogService,'Help','27')" tooltipPosition="left"
          aria-hidden="true"></button>
          </div>
      </div>
    </div>
   
  <div class="grid">
  <div class="col-12 md:col-3 lg:col-3 sm:col-6">
    <label class="label-spacing bold-red-text" for="productid">Products</label>
    <p-dropdown [pTooltip]="getSelectedProductTooltip()" [options]="filterProductData" [(ngModel)]="selectedProduct" optionLabel="productname"
      (onChange)="getParams2($event,'Products')" [resetFilterOnHide]="true" optionValue="productid" styleClass="fixed-width-dropdown-filter"
      inputId="productid" [filter]="true" placeholder="Select Product" appendTo="body"  pTooltip="Select Product" [showClear]="true">
    </p-dropdown>
  </div>

  <div class="col-12 md:col-3 lg:col-3 sm:col-6">
    <label class="label-spacing bold-red-text" for="activeFlag">Active Flag</label>
    <p-dropdown [pTooltip]="getSelectedFlagTooltip()"  [options]="activeFlagOptions" [(ngModel)]="selectedActiveFlag" optionLabel="activeFlagName"
      (onChange)="getParams2($event,'Active Flag')" optionValue="activeFlagId" styleClass="fixed-width-dropdown-filter" [resetFilterOnHide]="true"
      inputId="activeFlagId" [filter]="true" placeholder="Select Active Flag" appendTo="body" pTooltip="Select Active Flag" [showClear]="true">
    </p-dropdown>
  </div>

  <div class="col-12 md:col-3 lg:col-3 sm:col-6">
    <label class="label-spacing bold-red-text" for="userType">User Type</label>
    <p-dropdown [pTooltip]="getSelectedUserTypeTooltip()" [options]="userTypeOptions" [(ngModel)]="selectedUserType" optionLabel="userTypeName"
      (onChange)="getParams2($event,'User Type')" optionValue="userTypeId" styleClass="fixed-width-dropdown-filter" [resetFilterOnHide]="true"
      inputId="userTypeId" [filter]="true" placeholder="Select User Type" pTooltip="Select User Type" appendTo="body" [showClear]="true">
    </p-dropdown>
  </div>

  <div class="col-12 md:col-2 lg:col-2 sm:col-6">
    <p-button styleClass="refreshbtn reset-btn" pTooltip="Reset" severity="success" (click)="refreshFilters()">
      <i class="fa fa-refresh" aria-hidden="true"></i>
    </p-button>  
  </div>
</div>

  <div class="mr-0 tablehiegt">
    <p-table #dt [value]="formlistarray" [scrollable]="true"
      [globalFilterFields]="['product', 'userName', 'userEmail', 'status', 'createdOn', 'userType']"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" scrollDirection="horizontal"
      [rowHover]="true" [rows]="rowsize" [rowsPerPageOptions]="paginatorArray" [showCurrentPageReport]="true"
      [customSort]="customsort" (sortFunction)="this.Utilityservice.customSort($event)" [resizableColumns]="true" columnResizeMode="expand"
      [paginator]="formlistarray.length > 0" [sortOrder]="1" responsiveLayout="scroll" sortField="userName"
      scrollHeight="{{commonScrollHeight}}"
      (onPage)="handlePageChange($event)" [first]="currentPageIndex">

      <ng-template pTemplate="caption">
        <div class="table-header">
          <div class="grid">
            <div class="col-12 md:col-10 sm:col-12 lg:col-10">
              <span class="p-input-icon-lft">
                <i icon="pi pi-search"></i>
                <input class="form-control" pInputText type="text" id="tablesearch"
                  (input)="dt.filterGlobal($any($event.target).value, 'contains'); searchTerm = $any($event.target).value;" placeholder="Search in Unlicensed Users"
                  class="tablesearch" pTooltip="Enter Search Criteria" tooltipPosition="top" />
              </span>
            </div>
            <div class="col-12 lg:col-2 md:col-2 sm:col-12 ">
              <div class="iconexcel" pTooltip="Download Data" tooltipPosition="bottom" (click)="exceDownloadModel()">
              </div>
 
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th style="width: 5px !important;" class="tableaction">Action</th>
          <ng-container *ngFor="let col of _selectedColumns">
            <th pResizableColumn [pSortableColumn]="col.field" *ngIf="col.isChecked">
              {{col.header}}<p-sortIcon [field]="col.field"></p-sortIcon>
              <p-columnFilter *ngIf="col.field !== 'status'" type="text" [field]="col.field" display="menu"></p-columnFilter>
            </th>
          </ng-container>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-data>
        <tr>
          <td style="width: 5px !important;">
            <div style="display: flex; gap: 0px;">
              <span class="actionItm" pTooltip="Modify" tooltipPosition="left">
                <i class="fa fa-edit" (click)="show('Modify Unlicensed User', data, data.deleteFlag)"></i> 
              </span>
              <span *ngIf="data.deleteFlag == 'Y'" class="actionItm" pTooltip="Delete" tooltipPosition="left">
                <i class="p-element fa fa-trash-o red-icon" (click)="deleteUser(data.userid)"
                  style="cursor: pointer;color: red;"></i>
              </span>
            </div>
          </td>

          <ng-container *ngFor="let col of _selectedColumns">
            <!-- <td *ngIf="col.isChecked" [style.width]="col.width" [class]="col.class" >
              <span *ngIf="col.field !== 'status'" pTooltip="{{ data[col.field] }}" tooltipPosition="left">
                {{ data[col.field] }}
              </span>
              <span *ngIf="col.field === 'status'">
                <i *ngIf="data[col.field] === 'Active'" pTooltip="Active" tooltipPosition="left" class="fa fa-flag"
                  aria-hidden="true" style="color: green;"></i>
                <i *ngIf="data[col.field] !== 'Active'" pTooltip="Inactive" tooltipPosition="left" class="fa fa-flag"
                  aria-hidden="true" style="color: red;"></i>
              </span>
            </td> -->
            <td *ngIf="col.isChecked" [style.width]="col.width" [class]="col.class">
              <span *ngIf="col.field !== 'status'" pTooltip=" {{data[col.field]}}" tooltipPosition="left"
                [innerHTML]="highlight(data[col.field],searchTerm)"></span>
              <span *ngIf="col.field === 'status'">
                <i *ngIf="data[col.field] === 'Active'" pTooltip="Active" tooltipPosition="left" class="fa fa-flag"
                  aria-hidden="true" style="color: green;"></i>
                <i *ngIf="data[col.field] !== 'Active'" pTooltip="Inactive" tooltipPosition="left" class="fa fa-flag"
                  aria-hidden="true" style="color: red;"></i>
              </span>
            </td>
          </ng-container>
        </tr>
      </ng-template>
       <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7" class="datanotfound">
            No data available
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>


</p-card>